import { RestApiRequest } from "../Models/RestApiRequest";
import { fetchData } from "./BaseService";

export const isValidLicenseCode = async (projectname: string, code: string) => {
  var request: RestApiRequest = {
    url: "/api/licenses/validate",
    method: "POST",
    body: { projectname: projectname, licensekey: code },
    headers: { "Content-type": "application/json; charset=UTF-8" },
  };
  const response = await fetchData(request);
  return response;
};

export const redeemLicenseForProjectAsync = async (
  projectName: string,
  key: string
) => {
  var request: RestApiRequest = {
    url: "/api/licenses/redeem",
    method: "POST",
    body: { projectname: projectName, licensekey: key },
    headers: { "Content-type": "application/json; charset=UTF-8" },
  };

  const response = await fetchData(request);
  return response;
};

export const updateLicenseForProjectAsync = async (
  projectName: string,
  key: string
) => {
  var request: RestApiRequest = {
    url: "/api/licenses/update",
    method: "POST",
    body: { projectname: projectName, licensekey: key },
    headers: { "Content-type": "application/json; charset=UTF-8" },
  };

  const response = await fetchData(request);
  return response;
};

export const getProjectLicenses = async (projectname: string) => {
  var request: RestApiRequest = {
    url: "/api/licenses/get?projectname=" + projectname,
    method: "GET",
    headers: { "Content-type": "application/json; charset=UTF-8" },
  };
  const response = await fetchData(request);
  return response;
};
